import React from 'react';

export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('[App] Unhandled render error', error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <main className="min-h-screen bg-navy-dark px-6 py-12 text-textLight flex items-center justify-center">
        <section className="max-w-md rounded-xl border border-teal/40 bg-navy p-6 text-center shadow-xl">
          <h1 className="text-xl font-semibold">We could not open this screen</h1>
          <p className="mt-2 text-sm text-textLight/75">Please retry. If the problem continues, contact SPES support.</p>
          <button onClick={() => window.location.reload()} className="mt-5 rounded-lg bg-teal px-4 py-2 font-medium text-white hover:bg-teal-light">
            Retry
          </button>
        </section>
      </main>
    );
  }
}
